import React from 'react';
import { UnpublishRoute } from '@routific/hive/v5';
import { IllustrationBox } from '../styles';

const UnpublishIllustration: React.FC = () => (
  <IllustrationBox>
    <UnpublishRoute />
  </IllustrationBox>
);

export default UnpublishIllustration;
